// Initialize all animations after products are loaded
function initializeAnimations() {
    // Wheel scroll functionality
    (function () {
        const scrollSection = document.getElementById('hScroll');

        if (scrollSection) {
            let isScrolling = false;
            let targetScroll = scrollSection.scrollLeft;
            let animationFrameId = null;
            let hasReachedEnd = false;
            let lastScrollLeft = scrollSection.scrollLeft;

            function smoothScroll() {
                const current = scrollSection.scrollLeft;
                const distance = targetScroll - current;

                if (Math.abs(distance) > 0.5) {
                    scrollSection.scrollLeft = current + distance * 0.1;
                    animationFrameId = requestAnimationFrame(smoothScroll);
                } else {
                    isScrolling = false;
                    animationFrameId = null;
                    lastScrollLeft = scrollSection.scrollLeft;
                }
            }

            window.cancelWheelScroll = function () {
                if (animationFrameId) {
                    cancelAnimationFrame(animationFrameId);
                    animationFrameId = null;
                }
                isScrolling = false;
                targetScroll = scrollSection.scrollLeft;
                lastScrollLeft = scrollSection.scrollLeft;
            };

            window.syncTargetScroll = function (newValue) {
                targetScroll = newValue;
            };

            document.addEventListener(
                'wheel',
                function (e) {
                    const isInsideDrawer = e.target.closest('#CartDrawer, #custom-cart-drawer');
                    if (isInsideDrawer) {
                        return;
                    }

                    if (scrollSection.scrollWidth > scrollSection.clientWidth) {
                        const maxScroll = scrollSection.scrollWidth - scrollSection.clientWidth;

                        // Detect horizontal scrolling (touchpad left/right swipe)
                        const isHorizontalScroll = Math.abs(e.deltaX) > Math.abs(e.deltaY);

                        if (isHorizontalScroll && e.deltaX !== 0) {
                            // Handle natural horizontal scroll from touchpad
                            e.preventDefault();
                            const scrollMultiplier = 2;
                            targetScroll += e.deltaX * scrollMultiplier;
                            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

                            if (!isScrolling) {
                                isScrolling = true;
                                requestAnimationFrame(smoothScroll);
                            }
                            return;
                        }

                        // Existing vertical-to-horizontal logic
                        const atEnd = targetScroll >= maxScroll - 5;
                        const atStart = targetScroll <= 5;
                        const scrollingDown = e.deltaY > 0;
                        const scrollingUp = e.deltaY < 0;
                        const pageAtTop = window.scrollY <= 0;

                        if (scrollingDown && !atEnd) {
                            e.preventDefault();
                            hasReachedEnd = false;
                            const scrollMultiplier = 2;
                            targetScroll += e.deltaY * scrollMultiplier;
                            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

                            if (!isScrolling) {
                                isScrolling = true;
                                requestAnimationFrame(smoothScroll);
                            }
                            return;
                        }

                        if (atEnd && scrollingDown) {
                            hasReachedEnd = true;
                            return;
                        }

                        if (hasReachedEnd && scrollingDown) {
                            return;
                        }

                        if (hasReachedEnd && scrollingUp && pageAtTop) {
                            hasReachedEnd = false;
                            e.preventDefault();
                            const scrollMultiplier = 2;
                            targetScroll += e.deltaY * scrollMultiplier;
                            targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));

                            if (!isScrolling) {
                                isScrolling = true;
                                requestAnimationFrame(smoothScroll);
                            }
                            return;
                        }

                        if (hasReachedEnd && scrollingUp) {
                            return;
                        }

                        e.preventDefault();
                        const scrollMultiplier = 2;
                        const newTarget = targetScroll + e.deltaY * scrollMultiplier;
                        targetScroll = Math.max(0, Math.min(newTarget, maxScroll));

                        if (!isScrolling) {
                            isScrolling = true;
                            requestAnimationFrame(smoothScroll);
                        }
                    }
                },
                { passive: false }
            );
        }
    })();

    // Drag scroll functionality
    function enableDragScroll(element) {
        let pos = { top: 0, left: 0, x: 0, y: 0 };
        let isDragging = false;
        let velocity = { x: 0, y: 0 };
        let lastPos = { x: 0, y: 0 };
        let lastTime = 0;
        let momentumID;

        const mouseDownHandler = (e) => {
            // Don't start dragging if clicking on a link or button
            if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') {
                return;
            }

            // Cancel wheel scroll animation
            if (window.cancelWheelScroll) {
                window.cancelWheelScroll();
            }

            // Cancel any ongoing momentum
            cancelMomentum();

            isDragging = true;
            element.classList.add('grabbing');

            pos = {
                left: element.scrollLeft,
                top: element.scrollTop,
                x: e.clientX,
                y: e.clientY,
            };

            lastPos = { x: e.clientX, y: e.clientY };
            lastTime = Date.now();
            velocity = { x: 0, y: 0 };

            element.style.scrollBehavior = 'auto';
        };

        const mouseMoveHandler = (e) => {
            if (!isDragging) return;

            const currentTime = Date.now();
            const timeDiff = currentTime - lastTime;

            if (timeDiff > 0) {
                const dx = e.clientX - pos.x;
                const dy = e.clientY - pos.y;

                element.scrollTop = pos.top - dy;
                element.scrollLeft = pos.left - dx;

                // Calculate velocity
                velocity.x = (e.clientX - lastPos.x) / timeDiff;
                velocity.y = (e.clientY - lastPos.y) / timeDiff;

                lastPos = { x: e.clientX, y: e.clientY };
                lastTime = currentTime;
            }
        };

        const mouseUpHandler = () => {
            if (!isDragging) return;

            isDragging = false;
            element.classList.remove('grabbing');

            // Sync targetScroll with current scroll position
            if (window.syncTargetScroll) {
                window.syncTargetScroll(element.scrollLeft);
            }

            // Start momentum scrolling
            beginMomentumTracking();
        };

        const beginMomentumTracking = () => {
            cancelMomentum();
            momentumID = requestAnimationFrame(momentumLoop);
        };

        const cancelMomentum = () => {
            if (momentumID) {
                cancelAnimationFrame(momentumID);
                momentumID = null;
            }
        };

        const momentumLoop = () => {
            // Apply velocity to scroll position
            element.scrollLeft -= velocity.x * 10;
            element.scrollTop -= velocity.y * 16;

            // Keep targetScroll in sync during momentum
            if (window.syncTargetScroll) {
                window.syncTargetScroll(element.scrollLeft);
            }

            // Apply friction (deceleration)
            velocity.x *= 0.95;
            velocity.y *= 0.95;

            // Stop if velocity is very small
            if (Math.abs(velocity.x) > 0.01 || Math.abs(velocity.y) > 0.01) {
                momentumID = requestAnimationFrame(momentumLoop);
            } else {
                velocity = { x: 0, y: 0 };
            }
        };

        element.addEventListener('mousedown', mouseDownHandler);
        document.addEventListener('mousemove', mouseMoveHandler);
        document.addEventListener('mouseup', mouseUpHandler);

        // Cancel momentum on scroll wheel
        element.addEventListener('wheel', cancelMomentum);

        // Prevent text selection and image dragging
        element.addEventListener('dragstart', (e) => e.preventDefault());

        // Set scroll behavior immediately so wheel scrolling works from the start
        element.style.scrollBehavior = 'auto';
    }

    // Initialize drag scroll
    (function () {
        const scrollSection = document.getElementById('hScroll');
        if (scrollSection) {
            enableDragScroll(scrollSection);
        }
    })();

    // Lifestyle Image Animation on Scroll
    (function () {
        const scrollSection = document.getElementById('hScroll');
        const lifestyleImages = document.querySelectorAll('.lifestyle-image-desktop img');

        if (scrollSection && lifestyleImages.length > 0) {
            // Store the last known progress for each image
            const imageStates = new Map();

            function updateLifestyleImages() {
                const scrollLeft = scrollSection.scrollLeft;
                const viewportWidth = scrollSection.offsetWidth;
                const viewportRight = scrollLeft + viewportWidth;

                lifestyleImages.forEach((img, index) => {
                    const container = img.closest('.product-grid-item');
                    if (!container) return;

                    // Get the position of the image container relative to the scroll section
                    const imageContainer = img.closest('.lifestyle-image-container') || img.closest('.lifestyle-image');
                    if (!imageContainer) return;

                    const imageLeft = imageContainer.offsetLeft + container.offsetLeft;
                    const imageRight = imageLeft + imageContainer.offsetWidth;
                    const imageCenter = imageLeft + (imageContainer.offsetWidth / 2);

                    // Calculate progress based on image center position relative to viewport
                    // Progress reaches 1 when the right edge of image passes viewport right edge
                    const distanceFromRight = viewportRight - imageCenter;
                    const extendedViewportWidth = viewportWidth + (imageContainer.offsetWidth);
                    const progress = distanceFromRight / extendedViewportWidth;

                    // Clamp progress between 0 and 1
                    const clampedProgress = Math.max(0, Math.min(1, progress));

                    // Store the progress
                    imageStates.set(index, clampedProgress);

                    // Calculate scale (1 to 1.2) - scales up as progress increases
                    const scale = 1 + (clampedProgress * 0.3);

                    // Calculate translateX using percentages
                    // Start at -10%, end at 5% (total range of 15%)
                    const startPercent = -10;
                    const endPercent = 15;
                    const translateXPercent = startPercent + (clampedProgress * (endPercent - startPercent));

                    // Apply transform
                    img.style.transform = `translate(${translateXPercent}%, 0%) scale(${scale})`;
                });
            }

            // Update on scroll
            scrollSection.addEventListener('scroll', updateLifestyleImages);

            // Initial update
            updateLifestyleImages();
        }
    })();

    // Main Product Image Parallax Animation on Scroll
    (function () {
        const scrollSection = document.getElementById('hScroll');
        const mainProductImages = document.querySelectorAll('.main-product-image');

        // Track scroll state for each image
        const imageStates = new Map();

        mainProductImages.forEach(img => {
            imageStates.set(img, {
                lastScroll: 0,
                lastTime: Date.now(),
                velocity: 0,
                offset: 0,
                targetOffset: 0
            });
        });

        let lastScrollLeft = scrollSection.scrollLeft;
        let lastTime = Date.now();
        let rafId = null;

        // Handle scroll event
        scrollSection.addEventListener('scroll', function () {
            const now = Date.now();
            const dt = Math.max(now - lastTime, 1);
            const scrollLeft = scrollSection.scrollLeft;
            const scrollDelta = scrollLeft - lastScrollLeft;

            // Calculate velocity (pixels per millisecond)
            const velocity = scrollDelta / dt;

            mainProductImages.forEach(img => {
                const state = imageStates.get(img);
                state.velocity = velocity;

                // Set target offset based on velocity (adjust multiplier for more/less effect)
                state.targetOffset = velocity * 20; // 25 is the sensitivity multiplier
            });

            lastScrollLeft = scrollLeft;
            lastTime = now;

            // Start animation loop if not already running
            if (!rafId) {
                animate();
            }
        });

        // Animation loop with spring physics
        function animate() {
            if (window.innerWidth < 768) {
                return;
            }
            let hasMovement = false;

            mainProductImages.forEach(img => {
                const state = imageStates.get(img);

                // Spring physics parameters
                const stiffness = 0.05; // How quickly it springs back (0-1)
                const damping = 0.05;    // How much bounce/oscillation (0-1)

                // Calculate spring force
                const force = (state.targetOffset - state.offset) * stiffness;
                state.velocity = state.velocity * damping + force;
                state.offset += state.velocity;

                // Apply transform
                img.style.transform = `translateX(${state.offset}px)`;

                // Check if still moving (threshold for stopping animation)
                if (Math.abs(state.velocity) > 0.01 || Math.abs(state.offset - state.targetOffset) > 0.01) {
                    hasMovement = true;
                } else {
                    // Snap to final position
                    state.offset = state.targetOffset;
                    state.velocity = 0;
                    img.style.transform = `translateX(${state.offset}px)`;
                }
            });

            // Continue animation loop if there's still movement
            if (hasMovement) {
                rafId = requestAnimationFrame(animate);
            } else {
                rafId = null;
            }
        }

        // Reset when scrolling stops
        let scrollTimeout;
        scrollSection.addEventListener('scroll', function () {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                mainProductImages.forEach(img => {
                    const state = imageStates.get(img);
                    state.targetOffset = 0;
                });

                if (!rafId) {
                    animate();
                }
            }, 100); // Wait 100ms after scroll stops to spring back
        });
    })();

    // Simple fade-in animation for horizontal/vertical scroll
    (function () {
        const scrollContainer = document.getElementById('hScroll');
        if (!scrollContainer) return;

        // Detect if mobile (vertical scroll) or desktop (horizontal scroll)
        const isMobile = window.innerWidth < 768;

        // Get all product info containers
        const productInfos = scrollContainer.querySelectorAll('.product-info');

        // Set initial state for all text elements
        productInfos.forEach(info => {
            const h3 = info.querySelector('h3');
            const p = info.querySelector('p');
            const price = info.querySelector('.product-price')

            if (h3) {
                h3.style.opacity = '0';
                h3.style.transform = 'translateY(20px)';
                h3.style.transition = 'opacity 0.8s, transform 0.8s';
                h3.dataset.animated = 'false';
            }
            if (price) {
                price.style.opacity = '0';
                price.style.transform = 'translateY(20px)';
                price.style.transition = 'opacity 0.8s, transform 0.8s';
                price.dataset.animated = 'false';
            }
            if (p) {
                p.style.opacity = '0';
                p.style.transform = 'translateY(20px)';
                p.style.transition = 'opacity 0.8s, transform 0.8s';
                p.dataset.animated = 'false';
            }
        });

        // Check if element is in viewport
        function isInViewport(el) {
            const rect = el.getBoundingClientRect();

            if (isMobile) {
                // Vertical scroll detection for mobile
                return (
                    rect.top < window.innerHeight - 100 &&
                    rect.bottom > 100
                );
            } else {
                // Horizontal scroll detection for desktop
                const containerRect = scrollContainer.getBoundingClientRect();
                return (
                    rect.left < containerRect.right - 100 &&
                    rect.right > containerRect.left + 100
                );
            }
        }

        // Animate product info (fade in title and description)
        function animateProductInfo(info) {
            const h3 = info.querySelector('h3');
            const price = info.querySelector('.product-price');
            const p = info.querySelector('p');

            if (h3 && h3.dataset.animated === 'false') {
                h3.dataset.animated = 'true';
                h3.style.opacity = '1';
                h3.style.transform = 'translateY(0)';
            }

            if (price && price.dataset.animated === 'false') {
                price.dataset.animated = 'true';
                price.style.opacity = '1';
                price.style.transform = 'translateY(0)';
            }

            if (p && p.dataset.animated === 'false') {
                p.dataset.animated = 'true';
                p.style.opacity = '1';
                p.style.transform = 'translateY(0)';
            }
        }

        function checkElements() {
            productInfos.forEach(info => {
                if (isInViewport(info)) {
                    animateProductInfo(info);
                }
            });
        }

        // Initial check on page load - wait a brief moment for layout to settle
        setTimeout(() => {
            checkElements();
        }, 100);

        if (isMobile) {
            // For mobile: listen to window scroll (vertical)
            window.addEventListener('scroll', checkElements);
        } else {
            // For desktop: listen to container scroll (horizontal)
            scrollContainer.addEventListener('scroll', checkElements);
        }

        // Also check on window resize
        window.addEventListener('resize', checkElements);
    })();

    // Delayed load for second product and trigger animations
    (function () {
        if (window.innerWidth < 768) return;
        const scrollContainer = document.getElementById('hScroll');
        const productGridItems = document.querySelectorAll('.product-grid-item');

        if (!scrollContainer || productGridItems.length < 2) return;

        const secondProduct = productGridItems[1];

        // Hide second product initially
        secondProduct.style.opacity = '0';
        secondProduct.style.transform = 'translateX(50px)';
        secondProduct.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';

        // Delay before showing second product
        setTimeout(() => {
            // Animate second product in
            secondProduct.style.opacity = '1';
            secondProduct.style.transform = 'translateX(0)';

            // Trigger all other animations after second product starts appearing
            setTimeout(() => {
                // Trigger scroll event to activate other animations
                const scrollEvent = new Event('scroll');
                scrollContainer.dispatchEvent(scrollEvent);

                // Also trigger for window in case of mobile
                if (window.innerWidth < 768) {
                    window.dispatchEvent(scrollEvent);
                }

                // Force check of all animated elements
                const productInfos = scrollContainer.querySelectorAll('.product-info');
                productInfos.forEach(info => {
                    const h3 = info.querySelector('h3');
                    const p = info.querySelector('p');
                    const price = info.querySelector('.product-price');

                    if (h3 && h3.dataset.animated === 'false') {
                        const rect = info.getBoundingClientRect();
                        const containerRect = scrollContainer.getBoundingClientRect();

                        if (rect.left < containerRect.right - 100 && rect.right > containerRect.left + 100) {
                            h3.dataset.animated = 'true';
                            h3.style.opacity = '1';
                            h3.style.transform = 'translateY(0)';
                        }
                    }

                    if (p && p.dataset.animated === 'false') {
                        const rect = info.getBoundingClientRect();
                        const containerRect = scrollContainer.getBoundingClientRect();

                        if (rect.left < containerRect.right - 100 && rect.right > containerRect.left + 100) {
                            p.dataset.animated = 'true';
                            p.style.opacity = '1';
                            p.style.transform = 'translateY(0)';
                        }
                    }

                    if (price && price.dataset.animated === 'false') {
                        const rect = info.getBoundingClientRect();
                        const containerRect = scrollContainer.getBoundingClientRect();

                        if (rect.left < containerRect.right - 100 && rect.right > containerRect.left + 100) {
                            price.dataset.animated = 'true';
                            price.style.opacity = '1';
                            price.style.transform = 'translateY(0)';
                        }
                    }
                });
            }, 200); // Small delay after second product starts animating

        }, 600); // Initial delay before second product appears
    })();

    // Text Scramble Class
    class TextScrambleViewMore {
        constructor(el) {
            this.el = el;
            this.chars = '!<>-_\\/[]{}—=+*^#abfghjkrw';
            this.update = this.update.bind(this);
        }

        setText(newText) {
            const oldText = this.el.textContent;
            const length = Math.max(oldText.length, newText.length);
            const promise = new Promise((resolve) => this.resolve = resolve);
            this.queue = [];

            for (let i = 0; i < length; i++) {
                const from = oldText[i] || '';
                const to = newText[i] || '';
                const start = 0;
                const end = 20 + (i * 3);
                this.queue.push({ from, to, start, end });
            }

            cancelAnimationFrame(this.frameRequest);
            this.frame = 0;
            this.update();
            return promise;
        }

        update() {
            let output = '';
            let complete = 0;

            for (let i = 0, n = this.queue.length; i < n; i++) {
                let { from, to, start, end, char } = this.queue[i];

                if (this.frame >= end) {
                    complete++;
                    output += to;
                } else if (this.frame >= start) {
                    if (!char || Math.random() < 0.28) {
                        char = this.randomChar();
                        this.queue[i].char = char;
                    }
                    output += `<span style="color: gray; display: inline-block; width: 1ch;">${char}</span>`;
                } else {
                    output += from;
                }
            }

            this.el.innerHTML = output;

            if (complete === this.queue.length) {
                this.el.textContent = this.queue.map(item => item.to).join('');
                this.resolve();
            } else {
                this.frameRequest = requestAnimationFrame(this.update);
                this.frame++;
            }
        }

        randomChar() {
            return this.chars[Math.floor(Math.random() * this.chars.length)];
        }
    }

    // Initialize text scramble for view collection button
    (function () {
        const button = document.querySelector('.view-collection-button');
        const textElement = document.querySelector('.view-collection-button-text');

        if (button && textElement) {
            const fx = new TextScrambleViewMore(textElement);
            const originalText = textElement.textContent;
            let isAnimating = false;

            button.addEventListener('mouseenter', function () {
                if (isAnimating) return;

                isAnimating = true;
                fx.setText(originalText).then(() => {
                    isAnimating = false;
                });
            });
        }

        // Initialize for brand store link
        const brandLinks = document.querySelectorAll('.brand-store-link-text');

        brandLinks.forEach(function (textElement) {
            const parentLink = textElement.closest('a');

            if (parentLink) {
                const fx = new TextScrambleViewMore(textElement);
                const originalText = textElement.textContent;
                let isAnimating = false;

                parentLink.addEventListener('mouseenter', function () {
                    if (isAnimating) return;

                    isAnimating = true;
                    fx.setText(originalText).then(() => {
                        isAnimating = false;
                    });
                });
            }
        });
    })();
}